import { useMemo } from "react";
import { useAgentForm } from "./AgentFormContext";
import ConceptCard from "./ConceptCard";
import { liveConceptCard, unpersistedConcepts } from "./formFlow";

/**
 * The concepts that have streamed in and are not rows of the thread yet.
 *
 * They arrive one by one while the job is still running, well before the transcript is
 * re-read, so this is what makes the set appear as it is written rather than all at
 * once. Each one is dropped the moment the thread has it (matched by id), at which
 * point the persisted card — with its real `stale` / `chosen` marks — takes its place.
 */
const LiveConcepts = () => {
  const { live, flow } = useAgentForm();
  const pending = useMemo(
    () => unpersistedConcepts(live.concepts.items, flow.persistedConceptIds),
    [live.concepts.items, flow.persistedConceptIds],
  );

  return (
    <>
      {pending.map((concept) => (
        <ConceptCard key={concept.id} data={liveConceptCard(concept)} />
      ))}
    </>
  );
};

export default LiveConcepts;
